<template>
    <div @touchmove.prevent="noScroll" :class="[loginShow ? 'come-login' : '', 'login-detail']">

        <div class="mask" @click="emitEvent('closeLogin')">
            <a class="close"><span class="icon-cross2"></span></a>
        </div>

        <div class="container">

            <div class="content">

                <div class="no-login" v-if="!isLogin">
                    <a class="log-in" @click="emitEvent('logIn')">{{ $t("login.logIn") }}</a>
                    <span class="line">|</span>
                    <a class="sign-up" @click="emitEvent('signUp')">{{ $t("login.signUp") }}</a>
                </div>

                <div class="login" v-if="isLogin">

                    <div class="user-info-wrap">
                        <div class="user-info">
                            <img class="user-avatar" :src="loginAvatarurl" alt="">
                            <a class="log-out" @click="emitEvent('logOut')">{{ $t("login.logOut") }}</a>
                        </div>
                    </div>

                    <ul class="cloud-items">

                        <li class="m-list dashboard item">
                            <router-link :to="{path:'/user/dashboard/'}">{{ $t("login.dashboard") }}</router-link>
                        </li>

                        <li class="m-list library item">
                            <router-link :to="{path:'/user/cloud-library/'}">{{ $t("login.videoNav") }}</router-link>
                        </li>

                        <li class="m-list library item">
                            <a target="_blank" :href="profileUrl">{{ $t("login.accountSettings") }}</a>
                        </li>

                        <!-- <li class="m-list account-settings item" :class="[showItems.settingsShow ? 'list-come' : '']">
                            <a @click="changeShowItems('settingsShow')">
                                <span>{{ $t("login.accountSettings") }}</span>
                                <i :class="[showItems.settingsShow ? 'icon-icon_arrow-up' : 'icon-icon_arrow-down']"></i>
                            </a>

                            <ul :class="[showItems.settingsShow ? 'list-come' : '','list-wrap']" v-show="showItems.settingsShow">
                                <li class="m-list">
                                    <a :href="profileUrl" target="_blank">{{ $t("login.profile") }}</a>
                                </li>
                                <li class="m-list">
                                    <a :href="accountSecurityUrl" target="_blank">{{ $t("login.accountSecurity") }}</a>
                                </li>
                            </ul>
                            
                        </li> -->
                    </ul>

                </div>

            </div>

            <div class="lang" :class="[showItems.langShow ? 'list-come' : '']" v-if="!FEATURE('main.multi_language')">
                
                <ul class="choose-box list-wrap" v-show="showItems.langShow">
                    <li class="m-list lang-box"  v-for="(item,index) in langList" @click="selectLang(item)" :key="index">
                        <a><span>{{ $t(`lang.mobile.${item}`) }}</span></a>
                    </li>
                </ul>

                <div class="m-list lang-res" :lang-res="langRes" @click="changeShowItems('langShow')">

                    <a>

                        <span>{{langRes}}</span>
                        <i :class="[showItems.langShow ? 'icon-icon_arrow-up' : 'icon-icon_arrow-down']"></i>

                    </a>
                    
                </div>
            </div>

        </div>

    </div>
</template>

<script type="text/ecmascript-6">
import { config } from 'CONFIG';
import { headerHandle } from '@/common/js/header';

export default {
    props: {
        loginId: {
            type: Number,
            default: 0
        },

        loginAvatarurl: {
            type: String,
            default: ''
        },

        loginShow: {
            type: Boolean,
            default: false
        }
    },

    data () {

        return {
            langList: config.langList,
            showItems: {

                langShow: false,
                settingsShow: false

            }
           
        };

    },

    computed: {
        isLogin () {

            return this.loginId;

        },

        profileUrl () {

            return config.accountCenterProfileUrl;

        },

        accountSecurityUrl () {

            return config.accountCenterSecurityUrl;

        },

        langRes () {

            let lang = this.$store.state.lang.lang;
            return this.$t( `lang.mobile.${lang}` );

        }

    },

    methods: {

        emitEvent ( name ) {

            this.$emit( name );
            
        },

        noScroll () {

            return false;

        },

        selectLang ( lang ) {

            this.$store.commit( 'SELECT_LANG', lang );
            this.showItems.langShow = false;
            this.$i18n.locale = lang;
            headerHandle( this.$route );
            
        },

        changeShowItems ( item ) {

            let currentItem = !this.showItems[item];

            for ( let key in this.showItems ) {

                this.showItems[key] = false;

            };

            this.showItems[item] = currentItem;

        }

    }

};
</script>

<style scoped rel="stylesheet/css" lang="less">

    .login-detail {
        position: fixed;
        z-index: 100000;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
        transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
    }

    .login-detail.come-login {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }

    .login-detail .list-come .m-list,
    .login-detail .list-come.m-list,
    .login-detail .list-come.lang {
        background-color: #fff;
    }

    .login-detail .list-wrap {
        padding: 0 0.3rem;
    }

    .login-detail .mask {
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
    }

    .login-detail .close {
        position: absolute;
        top: 0.28rem;
        right: 0.28rem;
    }

    .login-detail .close span {
        font-size: 0.4rem;
        color: #fff;
    }

    .login-detail .container {
        height: 100%;
        width: 66%;
        background-color: #fff;
        position: relative;
    }

    @media screen and (max-width: 750px) {
        .login-detail .container {
            width: 5.5rem;
        }
    }

    .login-detail .lang {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
        background-color: #f7f8f9;
    }

    .login-detail .list-wrap .m-list {
        font-size: 0.26rem;
        padding: 0.3rem 0;
    }

    .m-list {
        width: 100%;
        padding: 0.2rem 0;
        background-color: #f7f8f9;
        text-align: left;
        font-size: 0.32rem;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
    }

    .m-list a {
        width: 100%;
        box-sizing: border-box;
        display: block;
        color: #333;
        position: relative;
    }

    .m-list i {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        color: @theme;
        font-size: 0.22rem;
    }

    .login-detail .content {
        height: calc(100vh - 0.72rem);
        position: relative;
        background: url(~IMAGE/login/menu-bg.jpg) left bottom no-repeat;
        background-size: 2.8rem auto;
    }

    .login-detail .content .menu-bg-wrap {
        position: relative;
        left: 0;
        bottom: 0;
    }
    .login-detail .content .menu-bg-wrap img {
        max-height: 100%;
        max-width: 100%;
    }

    .login-detail .no-login {
        color: @theme;
        font-weight: 500;
        font-size: 0.32rem;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        text-align: center;
        transform: translate(-50%,-50%);
    }

    .login-detail .no-login .line {
        font-weight: 400;
    }

    .login-detail .no-login a {
        cursor: pointer;
    }

    .login-detail .login .user-info-wrap {
        height: 2rem;
        width: 100%;
        position: relative;
        padding: 0 0.3rem;
        background-color: #f7f8f9;
        box-sizing: border-box;
    }

    .login-detail .login .user-info {
        position: absolute;
        top: 50%;
        left: 0.3rem;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        text-align: left;
    }

    .login-detail .login .user-info .user-avatar {
        width: 1.22rem;
        height: 1.22rem;
        border-radius: 100%;
        border: 1px solid #f1f1f1;
    }

    .login-detail .login .user-info .log-out {
        color: @theme;
        font-weight: 500;
        font-size: 0.32rem;
        margin-left: 0.4rem;
        cursor: pointer;
    }

    .login-detail .login .cloud-items .item {
        padding-left: 0.3rem;
        padding-right: 0.3rem;
        border-top: 1px solid #ddd;
    }

    .login-detail .login .cloud-items .item:last-of-type {
        border-bottom: 1px solid #ddd;
    }

    @media screen and (max-width: 800px) {

        .login-detail .content {
            background-size: 4rem auto;
        }

    }

    @media screen and (max-width: 750px) {
        
        .login-detail .login .user-info-wrap {
            height: 4rem;
        }

        .m-list {
            padding: 0.3rem 0;
        }

        .login-detail .content {
            height: calc(100vh - 0.96rem);
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/loginDetail.vue